const {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  split,
} = require("@apollo/client")
const { WebSocketLink } = require("@apollo/client/link/ws")
const { getMainDefinition } = require("@apollo/client/utilities")
const fetch = require("node-fetch")
const { User } = require("./user")
const { PendingShare } = require("./pendingShare")
const { Environment } = require("./environment")
const { PendingTransfer } = require("./pendingTransfer")
const { Thing } = require("./thing")
const { Notification } = require("./notification")
const { AccessToken } = require("./accessToken")
const { FloatSeriesNode } = require("./floatSeriesNode")
const { CategorySeriesNode } = require("./categorySeriesNode")
const { TotpSecret } = require("./totpSecret")
const { FileSeriesNode } = require("./fileSeriesNode")
const Mutation = require("./mutation")

const createClient = (httpOptions, subscriptionOptions) => {
  let link
  const httpLink = new HttpLink({ ...httpOptions, fetch })

  if (subscriptionOptions) {
    const subClient = new SubscriptionClient(
      subscriptionOptions.uri,
      subscriptionOptions.options,
      ws
    )
    const wsLink = new WebSocketLink(subClient)

    link = split(
      // split based on operation type
      ({ query }) => {
        const { kind, operation } = getMainDefinition(query)
        return kind === "OperationDefinition" && operation === "subscription"
      },
      wsLink,
      httpLink
    )
  } else {
    link = httpLink
  }

  const client = new ApolloClient({
    // By default, this client will send queries to the
    //  `/graphql` endpoint on the same host
    link,
    cache: new InMemoryCache(),
  })

  return client
}

class GraphQLError extends Error {
  constructor(message, e) {
    super(message)
    this.fullError = e
  }
}

class Igloo {
  constructor(bearer, server) {
    this.client = createClient({
      uri: server || "https://v1.igloo.ooo/graphql",
      headers: {
        Authorization: bearer ? "Bearer " + bearer : "",
      },
      fetchPolicy: "no-cache",
    })

    const _query = this.client.query
    this.client.query = (...args) =>
      _query(...args).catch((e) => {
        if (
          e.networkError &&
          e.networkError.result &&
          e.networkError.result.errors &&
          e.networkError.result.errors.length !== 0
        ) {
          throw new Error(e.networkError.result.errors[0].message, e)
        } else {
          throw e
        }
      })

    const _mutate = this.client.mutate
    this.client.mutate = (...args) =>
      _mutate(...args).catch((e) => {
        if (
          e.networkError &&
          e.networkError.result &&
          e.networkError.result.errors &&
          e.networkError.result.errors.length !== 0
        ) {
          throw new GraphQLError(e.networkError.result.errors[0].message, e)
        } else {
          throw e
        }
      })
  }

  get query() {
    return new Query(this.client)
  }

  get mutation() {
    return new Mutation(this.client)
  }
}

class Query {
  constructor(client) {
    this.client = client
  }

  user(id) {
    return new User(this.client, id)
  }

  get totpSecret() {
    return new TotpSecret(this.client)
  }

  pendingShare(id) {
    return new PendingShare(this.client, id)
  }

  environment(id) {
    return new Environment(this.client, id)
  }

  pendingTransfer(id) {
    return new PendingTransfer(this.client, id)
  }

  thing(id) {
    return new Thing(this.client, id)
  }

  notification(id) {
    return new Notification(this.client, id)
  }

  accessToken(id) {
    return new AccessToken(this.client, id)
  }

  floatSeriesNode(id) {
    return new FloatSeriesNode(this.client, id)
  }

  categorySeriesNode(id) {
    return new CategorySeriesNode(this.client, id)
  }

  fileSeriesNode(id) {
    return new FileSeriesNode(this.client, id)
  }
}

module.exports = Igloo
